import {
  DEFAULT_CARD_LABEL,
  TRANSLATION_KEYS,
  UNDEFINED_LABEL,
} from "./constants";
import getCountryName from "oc/utils/get-country-name";
import getNationality from "oc/utils/get-nationality";

export const capitalize = (str: string) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

export const computeCardLabel = (def: { type: string; translation: string; label?: string }, data: any, t: (key: string) => string) => {
  let label = t(def.translation) || def.label || DEFAULT_CARD_LABEL;
  if (def.type === "contract") {
    if (
      data?.employmentType?.code === "5" ||
      data?.employmentType?.code === "6"
    ) {
      const raw = t(TRANSLATION_KEYS.CONTRACT_OF_SERVICES);
      return capitalize(raw);
    }
    const name = data?.jobClass?.name || "";
    return capitalize(name) || UNDEFINED_LABEL;
  }
  return label;
};

export const formatValue = (item: { type: string; value: string }, data: any, i18n: { language: string }) => {
  let value = data?.[item.value] ?? "";
  switch (item.type) {
    case "date":
    case "dateOfBirth":
      return value ? new Date(value).toLocaleDateString() : "";
    case "country":
    case "countryOfBirth":
      return getCountryName(value, i18n.language);
    case "nationality":
      return getNationality(value, i18n.language);
    case "subName":
    case "gender":
    case "maritalStatus":
      return value?.name || "";
    case "mothersName":
      return data?.mothersLastName
        ? `${data.mothersNamePrefix} ${data.mothersLastName} ${data.mothersFirstName} ${data.mothersFirstName2 || ""} ${data.mothersNameSuffix || ""}`.trim()
        : "";
    default:
      return value;
  }
};

export const getLastDividerIndex = (children: { type: string }[]) =>
  children
    .map((c, i) => (c.type === "divider" ? i : -1))
    .filter((i) => i >= 0)
    .pop();
